import * as Sentry from '@sentry/vue';

export default defineNuxtPlugin(() => {
  const {
    public: { sentry },
  } = useRuntimeConfig();

  if (!sentry.dsn) return;

  Sentry.init({
    app: useNuxtApp().vueApp,
    dsn: sentry.dsn,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
});
